import type { ReactNode } from 'react';
import { useSession } from '../../state/session';
import { FlashMessages } from '../AlertMessages/FlashMessages';
import { ErrorBoundary } from '../ErrorBoundary';
import { GlobalMessage } from '../GlobalMessage';
import { Sidebar } from '../Sidebar/Sidebar';
import './Main.css';

type MainProps = {
	children: ReactNode;
};

export const Main = ({ children }: MainProps): JSX.Element => {
	const { user } = useSession();
	return (
		<>
			{!user?.specialsOnly && <Sidebar />}
			<main>
				<FlashMessages />
				<GlobalMessage />
				<ErrorBoundary>{children}</ErrorBoundary>
			</main>
		</>
	);
};
